import { render, staticRenderFns } from "./TrueFalse.vue?vue&type=template&id=38d3ff56&scoped=true&"
import script from "./TrueFalse.vue?vue&type=script&lang=ts&"
export * from "./TrueFalse.vue?vue&type=script&lang=ts&"
import style0 from "./TrueFalse.vue?vue&type=style&index=0&id=38d3ff56&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d3ff56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VBtn,VRadio,VRadioGroup})
